module.exports = __webpack_public_path__ + "img/img_login_message.700256a4.png";